import { render, staticRenderFns } from "./BaseTradeInVoucherSection.vue?vue&type=template&id=6927edd6&scoped=true"
import script from "./BaseTradeInVoucherSection.vue?vue&type=script&lang=js"
export * from "./BaseTradeInVoucherSection.vue?vue&type=script&lang=js"
import style0 from "./BaseTradeInVoucherSection.vue?vue&type=style&index=0&id=6927edd6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6927edd6",
  null
  
)

export default component.exports